module.exports = __webpack_public_path__ + "img/avatar1.ff0fcdb1.png";